// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    apiKeys: "API Keys",
    pageDescription: "Manage API keys for external integrations",
    documentation: "Documentation",
    apiDocs: "API Docs",
    adminApiDocs: "Admin API Docs",
  },
  nb_NO: {
    settings: "Innstillinger",
    apiKeys: "API-nøkler",
    pageDescription: "Administrer API-nøkler for eksterne integrasjoner",
    documentation: "Dokumentasjon",
    apiDocs: "API-dokumentasjon",
    adminApiDocs: "Admin API-dokumentasjon",
  },
} as const;
